import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { TrosakDokumentStavka } from './trosak-dokument-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-trosak-dokument-stavka-modal-update',
  templateUrl: './trosak-dokument-stavka-modal-update.component.html'
})
export class TrosakDokumentStavkaModalUpdateComponent extends BaseModalUpdateComponent<TrosakDokumentStavka> {

  constructor(
    protected modalContainerService: ModalContainerService<TrosakDokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }



}
